<template>
  <div class="mobile" :class="{'is-active': getToggleMobileNavStatus}">
    <div class="mobile__inner">
      <!--  Navigation   -->
      <nav class="mobile__nav">
        <ul class="mobile__list">

          <li class="mobile__item">
            <router-link :to="{name: 'Home'}" class="mobile__link">{{ $t('home.home') }}</router-link>
          </li>

          <li class="mobile__item">
            <a href="javascript:;" class="mobile__link mobile__link--booking">{{ $t('home.booking') }}</a>

            <ul class="mobile__sub" :class="{'is-active': getToggleMobileNavStatus}">
              <li class="mobile__sub-item" v-for="location in getLocationsList" :key="location.id">
                <router-link class="mobile__sub-link" :to="{name: 'Events', params: {id: location.id} }" :style="locationStyles(location.color)">{{ location.title }}</router-link>
              </li>
            </ul>

          </li>

          <!-- <li class="mobile__item">
            <router-link :to="{name: 'Gallery'}" class="mobile__link">{{ $t('home.gallery') }}</router-link>
          </li> -->

          <li class="mobile__item">
            <a href="javascript:;" class="mobile__link mobile__link--booking">{{ $t('home.info') }}</a>

            <ul class="mobile__sub" :class="{'is-active': getToggleMobileNavStatus}">
              <li class="mobile__sub-item" v-for="location in getLocationsList" :key="location.id">
                <router-link class="mobile__sub-link" :to="{name: 'Infos', params: {id: location.id} }" :style="locationStyles(location.color)">{{ location.title }}</router-link>
              </li>
            </ul>

          </li>

        </ul>
      </nav>
      <!--  Call2action  -->
      <transition name="trs-fade-out" mode="out-in">
        <div key="1" class="mobile__c2a mobile__c2a--not-logged" v-if="!isLoggedIn">
          <router-link :to="{name: 'Register'}" class="button button--outline">{{ $t('home.register') }}</router-link>
          <router-link :to="{name: 'Login'}" class="button button--primary">{{ $t('home.login') }}</router-link>
        </div>

        <div key="2" class="mobile__c2a" v-else>
          <a href="#" class="mobile__btn" @click="logoutClickHandler"><img src="~@/assets/images/logout.svg" alt="Logout"></a>
          <a href="#" class="mobile__btn" @click="changeRoute({name: 'Profile.my-events'})"><img src="~@/assets/images/events.svg" alt="Events"></a>
          <a href="#" class="mobile__btn" @click="changeRoute({name: 'Profile.account'})"><img src="~@/assets/images/account.svg" alt="Account"></a>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
  import { mapGetters, mapActions } from 'vuex'
  export default {
    name: 'AppMobileNavigation',
    computed: {
      ...mapGetters('locations', ['getLocationsList']),
      ...mapGetters('toggleMobileNav', ['getToggleMobileNavStatus']),
      ...mapGetters('auth', ['isLoggedIn', 'getCurrentUser']),
    },
    watch: {
      '$route'() {
        this.setToggleMobileNav(false)
      }
    },
    mounted() {
      this.fetchLocations()
    },
    methods: {
      ...mapActions('locations', ['fetchLocations']),
      ...mapActions('toggleMobileNav', ['setToggleMobileNav']),
      ...mapActions('auth', ['logoutHandler']),
      locationStyles(color) {
        return {
          '--color': color,
          '--color-hover': color
        }
      },
      logoutClickHandler() {
        this.logoutHandler();
        this.setToggleMobileNav(false)
      },
      changeRoute(name) {
        this.setToggleMobileNav(false);
        this.$router.push(name).catch(()=>{});
      }
    }
  }
</script>
